import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';

export interface IInsurerServiceAddEditValidated {
    exportUntilDate: Date;
    insurerId: string;
    serviceId: string;
}

const insurerServiceEdit = Koi.object({
    exportUntilDate: Koi.koi().date().allow(null),
}).options({ convert: false, presence: 'required' });

export const insurerServiceEditSchema: ISchemaContainer<IInsurerServiceAddEditValidated> = {
    schema: insurerServiceEdit,
};

export const insurerServiceAddSchema: ISchemaContainer<IInsurerServiceAddEditValidated> = {
    schema: insurerServiceEdit.concat(
        Koi.object({
            insurerId: Koi.string().uuid(),
            serviceId: Koi.string().uuid(),
        }).options({ convert: false, presence: 'required' })
    ),
};
